import { GQL_ID, PersonalOffersInfo } from '@@types'
import { gql, useQuery } from '@apollo/client'

import { useAuth } from '@features/auth'

// Re-export types for external use
export type { PersonalOfferItem, PersonalOfferGroup, PersonalOffersInfo } from '@@types'

export type PersonalOffersQuery = {
  personalOffers: PersonalOffersInfo
}

type PersonalOffersQueryVariables = {
  shop_id: GQL_ID
}

const GQL_PERSONAL_OFFERS = gql`
  query PersonalOffers($shop_id: ID!) {
    personalOffers(shop_id: $shop_id) {
      campaignId
      brandXid
      activeFrom
      activeTo
      personalOffers {
        templateIndex
        offerXid
        items {
          xid
          templateIndex
          activeFrom
          activeTo
          preferenceType
          type
          preferenceValue
          actualValue
          name
          image {
            url
          }
          sort_order
          mechanicsType
          product {
            id
            xid
            name
            slug
            short_description
            images {
              url
            }
            price {
              current
              old
              discount_percent
            }
            in_stock
            is_adult
            weight {
              value
              unit
            }
            brand {
              name
            }
          }
        }
      }
    }
  }
`

export const useFetchPersonalOffers = (shopId?: GQL_ID) => {
  const { isAuthorized, requireRegistration } = useAuth()
  
  const { 
    data, 
    loading, 
    error, 
    refetch
  } = useQuery<PersonalOffersQuery, PersonalOffersQueryVariables>(GQL_PERSONAL_OFFERS, {
    variables: {
      shop_id: shopId || '1' // Default shop_id
    },
    skip: !isAuthorized || requireRegistration,
    errorPolicy: 'all'
  })

  const personalOffers = data?.personalOffers

  return { data, loading, error, refetch, personalOffers, isAuthorized }
}